import React from 'react';

export const ConfiguracaoContexto = React.createContext(null);